__turbopack_context__.v({
  "Haddings": "TestimonialsSection-module__g8XAva__Haddings",
  "section": "TestimonialsSection-module__g8XAva__section",
  "swiper-button-next": "TestimonialsSection-module__g8XAva__swiper-button-next",
  "swiper-button-prev": "TestimonialsSection-module__g8XAva__swiper-button-prev",
  "swiper-pagination-bullet": "TestimonialsSection-module__g8XAva__swiper-pagination-bullet",
  "swiper-pagination-bullet-active": "TestimonialsSection-module__g8XAva__swiper-pagination-bullet-active",
  "testimonialsBg": "TestimonialsSection-module__g8XAva__testimonialsBg",
  "testimonialsClr": "TestimonialsSection-module__g8XAva__testimonialsClr",
  "testimonialsClr0": "TestimonialsSection-module__g8XAva__testimonialsClr0",
  "textHad0": "TestimonialsSection-module__g8XAva__textHad0",
});
